export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_10-541aa4e1f6a42e9c3ac873dd1b24d589.gif";